import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'prop-document-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'prop-document-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'prop-document-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'prop-document-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'prop-document-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'prop-document-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'prop-document-overview__menu--activity',
    informations: 'prop-document-overview__menu--general-info',
    financialactivity: 'prop-document-overview__menu--financial-info',
    contacts: 'prop-document-overview__menu--contact-linked',
    addresses: 'prop-document-overview__menu--address',
    customfields: 'prop-document-overview__menu--cf',
    statistics: 'prop-document-overview__menu--stat',
    opportunity: 'prop-document-overview__menu--opportunity',
    estimate: 'prop-document-overview__menu--document',
    invoice: 'prop-document-overview__menu--document',
    delivery: 'prop-document-overview__menu--document',
    order: 'prop-document-overview__menu--document',
    creditnote: 'prop-document-overview__menu--document',
    proforma: 'prop-document-overview__menu--document',
    payments: 'prop-document-overview__menu--payment',
    bankaccount: 'prop-document-overview__menu--bank-account',
    recurring: 'prop-document-overview__menu--recurring',
    mandates: 'prop-document-overview__menu--mandate',
    timetracking: 'prop-document-overview__menu--timetracking',
    tickets: 'prop-document-overview__menu--ticket',
    project: 'prop-document-overview__menu--project',
    proposal: 'prop-document-overview__menu--proposal',
    emailingprofile: 'prop-document-overview__menu--mailing-list',
    massmailingMailinglist: 'prop-document-overview__menu--mailing-list',
    massmailingCampaignList: 'prop-document-overview__menu--mailing-list',
    receipts: 'prop-document-overview__menu--receipt',
    briefcase: 'prop-document-overview__menu--briefcase',
    activitycommentadd: 'prop-document-overview__activity--comment-add',
    emailadd: 'prop-document-overview__activity--email-add',
    calladd: 'prop-document-overview__activity--call-add',
    taskadd: 'prop-document-overview__activity--task-add',
    eventadd: 'prop-document-overview__activity--event-add',
    generalinfoedit1: 'prop-document-overview__section--general-info-edit-1',
    generalinfoedit2: 'prop-document-overview__section--general-info-edit-2',
    marketing: 'prop-document-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
